// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  noteId: __t.u64().primaryKey().name("note_id"),
  structureId: __t.u64().name("structure_id"),
  author: __t.identity(),
  authorName: __t.string().name("author_name"),
  text: __t.string(),
  at: __t.timestamp(),
});
